import { createSelector } from '@ngrx/store';

export const getIndustriesState = createSelector(
    (state: any) => state.industries,
    (state: any) => state.get('list')
);

export const getCreateIndustryState = createSelector(
    (state: any) => state.industries,
    (state: any) => state.get('createIndustry')
);

export const getUpdateIndustryState = createSelector(
    (state: any) => state.industries,
    (state: any) => state.get('updateIndustry')
);
 